import { render, staticRenderFns } from "./TrainingCalendarWeek.vue?vue&type=template&id=b1664328&scoped=true&"
import script from "./TrainingCalendarWeek.vue?vue&type=script&lang=ts&"
export * from "./TrainingCalendarWeek.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingCalendarWeek.vue?vue&type=style&index=0&id=b1664328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1664328",
  null
  
)

export default component.exports